const WORD_LIST_CACHE_KEY = 'lexio:user-word-list:v1';
const SAFE_FIELDS = ['word', 'slug', 'normalized', 'lang', 'hasDef', 'type'];

const isBrowserEnvironment = () => typeof window !== 'undefined' && !!window.localStorage;

const sanitizeEntries = (entries) =>
  entries.map((entry) => {
    const sanitizedEntry = {};
    SAFE_FIELDS.forEach((field) => {
      if (entry[field] !== undefined) {
        sanitizedEntry[field] = entry[field];
      }
    });
    return sanitizedEntry;
  });

export const loadCachedWordEntries = () => {
  if (!isBrowserEnvironment()) return null;

  try {
    const cachedValue = window.localStorage.getItem(WORD_LIST_CACHE_KEY);
    if (!cachedValue) return null;

    const parsedValue = JSON.parse(cachedValue);
    if (!Array.isArray(parsedValue)) return null;

    return parsedValue;
  } catch (error) {
    return null;
  }
};

export const storeCachedWordEntries = (entries) => {
  if (!isBrowserEnvironment() || !Array.isArray(entries)) return;

  try {
    const sanitizedEntries = sanitizeEntries(entries);
    const serializedValue = JSON.stringify(sanitizedEntries);
    window.localStorage.setItem(WORD_LIST_CACHE_KEY, serializedValue);
  } catch (error) {
    // Ignore storage failures so the network response still renders.
  }
};

export const clearCachedWordEntries = () => {
  if (!isBrowserEnvironment()) return;

  try {
    window.localStorage.removeItem(WORD_LIST_CACHE_KEY);
  } catch (error) {
    // Ignore removal failures; cache will be overwritten when possible.
  }
};
